var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex"},_vm._l((_vm.numbers),function(n,key){return _c('SlotNumber',{key:key,attrs:{"select":n,"timeout":_vm.wait,"start":key}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }